import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import styles from "./styles/icon-radio-button.css.js";
import Icon from "components/icon";
import IconButton from "@material-ui/core/IconButton";

const IconRadioButton = ({ id, classes, selected, iconName, onClick, label, ...props }) => {
  const handleClick = () => {
    onClick(id);
  };

  return (
    <IconButton
      id={id}
      component="span"
      onClick={handleClick}
      className={cn(classes.icon_radio_button, { [classes.icon_radio_button__selected]: selected })}
      {...props}
    >
      <Icon name={iconName} />
      <span className={classes.label}>{label}</span>
    </IconButton>
  );
};

IconRadioButton.propTypes = {
  /**
   * Indica si el radio button está seleccionado
   */
  selected: PropTypes.bool,
  /**
   * Id del radio button
   */
  id: PropTypes.string.isRequired,
  /**
   * Nombre del icono
   */
  iconName: PropTypes.string,
  /**
   * Etiqueta del icono
   */
  label: PropTypes.string,
  /**
   * Callback de click
   */
  onClick: PropTypes.func,
};

export default withStyles(styles)(IconRadioButton);
